var map = {
	"./breafIcon.svg": 5114,
	"./certificationIcon.svg": 1400,
	"./deliveryIcon.svg": 8976,
	"./developIcon.svg": 1941,
	"./orderIcon.svg": 1090,
	"./recipeIcon.svg": 922,
	"./sebesIcon.svg": 2916,
	"./suppliesIcon.svg": 1617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2791;